type Setting = {
  [key: string]: string | number
}
export const checkSetting = (setting: Setting, value: string | string[]) => {
  if (value) {
    const val = Array.isArray(value) ? value : [value]
    return val.some((item) => Boolean(Number(setting[item])))
  } else {
    return false
  }
}

export const hasSetting = (setting: Setting, value: string | string[]) => {
  if (!value) {
    return true
  }
  return checkSetting(setting, value)
}
